import {
  uploadFileToS3,
  uploadFileWithMultipart,
  uploadFile,
  shouldUseMultipartUpload,
} from "./s3-upload.service";

export * from "./s3-upload.service";

export const createEspisodeService = {
  uploadFileToS3,
  uploadFileWithMultipart,
  uploadFile,
  shouldUseMultipartUpload,
};
